import React, { Suspense } from "react";
// import { ProcessTagsStepComponent } from "@rankmi/ats-app";
import { Divider } from "antd";
// TODO: Eliminar este archivo

const StepsTagsConfig = ({ processId, isCheched, initialTags }) => {
  return (
    <Suspense fallback="">
      {/* <ProcessTagsStepComponent
        processId={processId}
        isCheched={isCheched}
        initialTags={initialTags}
        documentationUrl="https://support.rankmi.com/es/support/solutions/articles/72000571908-publicar-un-proceso"
      /> */}
      <Divider style={{margin: '5px 0 15px 0'}}/>
    </Suspense>
  );
};

export default StepsTagsConfig;
